import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class MunicipioService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getMunicipios(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/municipios' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getMunicipio(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/municipios/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getMunicipioByUf(ufId) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/municipios/uf/' + ufId)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
